const LOCALES = {
  ar: { name: 'Arabic', dir: 'rtl' },
  'de-DE': { name: 'German', dir: 'ltr' },
  'en-US': { name: 'English', dir: 'ltr' },
  'es-ES': { name: 'Spanish', dir: 'ltr' },
  'es-LA': { name: 'Latin American Spanish', dir: 'ltr' },
  'fi-FI': { name: 'Finnish', dir: 'ltr' },
  'fr-FR': { name: 'French', dir: 'ltr' },
  'fr-CA': { name: 'Québécois', dir: 'ltr' },
  'hu-HU': { name: 'Hungarian', dir: 'ltr' },
  'he-IL': { name: 'Hebrew', dir: 'rtl' },
  'id-ID': { name: 'Indonesian', dir: 'ltr' },
  'it-IT': { name: 'Italian', dir: 'ltr' },
  'ja-JP': { name: 'Japanese', dir: 'ltr' },
  'ko-KR': { name: 'Korean', dir: 'ltr' },
  'nl-NL': { name: 'Dutch', dir: 'ltr' },
  'pl-PL': { name: 'Polish', dir: 'ltr' },
  'pt-BR': { name: 'Brazilian Portuguese', dir: 'ltr' },
  'ru-RU': { name: 'Russian', dir: 'ltr' },
  'sv-SE': { name: 'Swedish', dir: 'ltr' },
  'th-TH': { name: 'Thai', dir: 'ltr' },
  'tr-TR': { name: 'Turkish', dir: 'ltr' },
  'vi-VN': { name: 'Vietnamese', dir: 'ltr' },
  'zh-TW': { name: 'Traditional Chinese', dir: 'ltr' },
};

module.exports = {
  LOCALES,
};
